var _g, _path, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 74,
    viewBox: "0 0 56 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_166_17809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9331 6C18.045 6 10 14.045 10 23.9331C10 26.9015 10.7422 29.8447 12.153 32.4552L26.9524 59.2212C27.1494 59.578 27.5248 59.7991 27.9331 59.7991C28.3413 59.7991 28.7167 59.578 28.9137 59.2212L43.7186 32.4464C45.124 29.8447 45.8661 26.9014 45.8661 23.933C45.8661 14.045 37.8212 6 27.9331 6Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9331 6C18.045 6 10 14.045 10 23.9331C10 26.9015 10.7422 29.8447 12.153 32.4552L26.9524 59.2212C27.1494 59.578 27.5248 59.7991 27.9331 59.7991C28.3413 59.7991 28.7167 59.578 28.9137 59.2212L43.7186 32.4464C45.124 29.8447 45.8661 26.9014 45.8661 23.933C45.8661 14.045 37.8212 6 27.9331 6Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2733 32.9306L11.2732 32.9307L11.2779 32.9391L26.077 59.7045C26.4505 60.3811 27.1619 60.7991 27.9331 60.7991C28.7043 60.7991 29.4156 60.3811 29.7892 59.7045L44.5937 32.9302L44.5938 32.9303L44.5984 32.9216C46.083 30.1733 46.8661 27.0665 46.8661 23.933C46.8661 13.4927 38.3735 5 27.9331 5C17.4927 5 9 13.4927 9 23.9331C9 27.0669 9.78322 30.1736 11.2733 32.9306Z",
    stroke: "white",
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3823 25.487V30.041H24.1683V17.441C24.6963 17.441 25.2663 17.435 25.8783 17.423C26.5023 17.411 27.1263 17.405 27.7503 17.405C28.6383 17.405 29.4063 17.519 30.0543 17.747C30.7143 17.963 31.2243 18.269 31.5843 18.665C31.9443 19.049 32.2083 19.475 32.3763 19.943C32.5443 20.399 32.6283 20.903 32.6283 21.455C32.6283 22.595 32.2203 23.561 31.4043 24.353C30.6003 25.145 29.4723 25.541 28.0203 25.541C27.2883 25.541 26.7423 25.523 26.3823 25.487ZM27.9663 19.475L26.3823 19.511V23.381C27.0183 23.441 27.5403 23.471 27.9483 23.471C28.6563 23.471 29.2203 23.297 29.6403 22.949C30.0723 22.601 30.2883 22.097 30.2883 21.437C30.2883 20.129 29.5143 19.475 27.9663 19.475Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 24,
    r: 13.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_166_17809",
    x: 0,
    y: 0,
    width: 55.8662,
    height: 73.7991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_166_17809"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_166_17809",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/Inactive.8fce209560be07f6dd24b82fae96f386.svg";
export { ForwardRef as ReactComponent };